module.exports = __webpack_public_path__ + "img/loading.ceaad3cb.gif";